import React from "react"
import Cabecalho from "../Cabecalho"
import { SelosPremiadosLista } from "./components/SelosPremiadosLista"

export function SeloPremiadoFornecedor() {
    return (
        <>
            <Cabecalho pagina="Selos Premiados" />
            <SelosPremiadosLista />
        </>
    )
}
